import { render, staticRenderFns } from "./catalog-category-page.vue?vue&type=template&id=74012e5c&"
import script from "./catalog-category-page.vue?vue&type=script&lang=ts&"
export * from "./catalog-category-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports